import React, { useState, useRef, useEffect } from "react";
import { User } from "../../../types";
import { Link } from "react-router";
import { UserCircleIcon } from '@heroicons/react/24/solid';

interface UserHeaderPanelProps {
    user: User;
    handleLogout: () => void;
}

const UserHeaderPanel: React.FC<UserHeaderPanelProps> = ({ user, handleLogout }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="relative" ref={dropdownRef}>
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center gap-2 p-2 rounded-lg"
            >
                <UserCircleIcon className="w-8 h-8 text-pacificblue-900 hover:text-pacificblue-700 transition-colors" />
            </button>

            {isOpen && (
                <div className="absolute right-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
                    <ul>
                        <li>
                            <button
                                className="block px-4 py-2 text-pacificblue-900"
                            >
                                Hello, <span className="font-bold">{user.first_name}</span>!
                            </button>
                        </li>
                        <li>
                            <Link
                                to="/settings"
                                className="block px-4 py-2 text-pacificblue-900 hover:bg-stone-200 transition-colors"
                                onClick={() => setIsOpen(false)}
                            >
                                Settings
                            </Link>
                        </li>
                        <li>
                            <button
                                onClick={() => {
                                    handleLogout();
                                    setIsOpen(false);
                                }}
                                className="block w-full text-left px-4 py-2 text-pacificblue-900 hover:bg-stone-200 transition-colors border-t border-gray-200"
                            >
                                Logout
                            </button>
                        </li>
                    </ul>
                </div>
            )}
        </div>
    );
};

export default UserHeaderPanel;